import { FieldBoolean, FieldString } from '@ps-int/datasync-client';

import { getDatasyncClient } from '../../helpers/datasync';
import { createLogger } from '../../helpers/loggerFacade';

const logger = createLogger('datasync-settings');

const SETTINGS_DB = 'telemost';
const SETTINGS_COLLECTION = 'settings';

const TELEMOST_SETTINGS_SCHEMA = {
    broadcastCaptionTooltipShown: FieldBoolean(),
    broadcastTutorialStep: FieldString(),
    checkDesktopAppExistence: FieldBoolean(),
    gridView2: FieldString(),
    isShownLimitMessage: FieldBoolean(),
    showMyVideo: FieldBoolean(),
    joinWithCameraOff: FieldBoolean(),
    joinWithMicrophoneOff: FieldBoolean(),
    noiseCancellationType: FieldString(),
    summarizationWelcomePopupWasShown: FieldBoolean(),
    summarizationStartPopupWasShown: FieldBoolean(),
};

export type DATASYNC_SETTINGS_KEYS = keyof typeof TELEMOST_SETTINGS_SCHEMA;

export const getUserSettings = async (userUid: string) => {
    const client = getDatasyncClient({ db: SETTINGS_DB, collection: SETTINGS_COLLECTION, userUid });
    try {
        return await client.getAll(TELEMOST_SETTINGS_SCHEMA);
    } catch (error) {
        logger.error(error, {
            method: 'getUserSettings',
        });
    }
};

export const setUserSettings = async (userUid: string, name: DATASYNC_SETTINGS_KEYS, value: string | boolean) => {
    const client = getDatasyncClient({ db: SETTINGS_DB, collection: SETTINGS_COLLECTION, userUid });

    try {
        await client.setValue(name, String(value));
    } catch (error) {
        logger.error(error, {
            method: 'setUserSettings',
        });
    }
};
